import { AppState } from '../types';
import { logger } from '../utils/logger';
import { ReportOptions, buildReportHtml } from './reportHtml';

/**
 * Opens the printable harness report in a new window and triggers the browser
 * print dialog, from which the user can save it as a PDF. Returns false if the
 * window could not be opened (e.g. blocked by a popup blocker).
 */
export function printReport(state: AppState, options: ReportOptions = {}): boolean {
  const html = buildReportHtml(state, options);
  const win = window.open('', '_blank');
  if (!win) {
    logger.storage.error('Could not open a window for the harness report (popup blocked?)');
    return false;
  }

  win.document.open();
  win.document.write(html);
  win.document.close();

  // Wait for the document (and its inline SVG) to lay out before printing.
  win.addEventListener('load', () => {
    win.focus();
    win.print();
  });

  return true;
}
